// Module
var code = "<div class=\"inline-help-wizard\"> <div class=\"inline-help-content\"> <div id=\"table-wrapper-selection-react-container\"></div> </div> <div class=\"inline-help-helptext open\" style=\"display:none\"></div> </div> ";
// Exports
export default code;